import(/* webpackMode: "eager" */ "/vercel/path0/app/[lng]/(landing)/landing/page.tsx");
